import useSuperAdminDataPoints from '../data/datapoint/superadmin/useSuperAdminDataPoints';
import useDataPointFunctions from '../data/datapoint/useDataPointFunctions';

const useDataPointLookup = (hardwareTypeId?: string) => {
  const { dataPoints } = useSuperAdminDataPoints(hardwareTypeId);

  const lookup = (dataPointId: string) =>
    dataPoints.data?.find((d) => d.id === dataPointId);

  return {
    isLoading: dataPoints.isLoading,
    lookup,
  };
};

const useDataPointFunctionLookup = () => {
  const { dataPointFunctions } = useDataPointFunctions();

  const lookup = (functionId: string) =>
    dataPointFunctions.data?.find((f) => f.id === functionId);

  return {
    isLoading: dataPointFunctions.isLoading,
    lookup,
  };
};

export const useSuperAdminDataPointLookups = (hardwareTypeId?: string) => {
  const { isLoading: dataPointLoading, lookup: dataPointLookup } =
    useDataPointLookup(hardwareTypeId);

  const { isLoading: functionsLoading, lookup: functionsLookup } =
    useDataPointFunctionLookup();

  const isLoading = dataPointLoading || functionsLoading;

  return {
    isLoading,
    dataPointLookup,
    functionsLookup,
  };
};
